import { useState } from "react";
import { productionSummaryMonthWise, productionSummaryToday } from "../../services/productionService";

export const useProductionSummaryToday = () => {

    const [summaryToday, setSummaryToday] = useState([]);
    const [summaryMonthWise, setSummaryMonthWise] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    const fetchTodayProductionSummary = async ({ company, fromDate, toDate }) => {
        const para = { p_companyid: company ?? 13, p_plantid: 1, p_from_date: fromDate, p_to_date: toDate };
        setIsLoading(true);
        try {
            const [todayData, monthlyData] = await Promise.all([
                productionSummaryToday(para),
                productionSummaryMonthWise(para)
            ]);

            setSummaryToday(todayData || []);
            setSummaryMonthWise(monthlyData || []);
            setIsLoading(false);
            return todayData || [];
        } catch (error) {
            alert(error.message);
            setIsLoading(false);
        }
    };






    return {
        summaryToday,
        fetchTodayProductionSummary,
        setSummaryToday,   // optional – if you need reset
        summaryMonthWise,
        setSummaryMonthWise,
        isLoading

    };
};
